// extracted by mini-css-extract-plugin
module.exports = {"inboxButton":"styles_inboxButton__1Piw_","unreadBadge":"styles_unreadBadge__3qRUG","modalContent":"styles_modalContent__2sTSJ","modal":"styles_modal__1fdkr"};